module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('propertySetup', {
    ref: "propertySetup"
  }), _vm._v(" "), _c('propertyList', {
    ref: "deleteData",
    on: {
      "delete-message": _vm.deleteProperty,
      "edit-property": _vm.editItemProperty
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44b57100"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/settings/itemProperty/property.vue
// module id = 2187
// module chunks = 0